<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbar class="home_one" />
  <PageBanner pageTitle="Frequently Asked Questions" mainTitle="FAQ" />
  <FAQAccordion />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbar from "../components/Layouts/ResponsiveNavbar.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import FAQAccordion from "../components/FAQ/FAQAccordion.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "FAQPage",
  components: {
    NavbarFive,
    ResponsiveNavbar,
    PageBanner,
    FAQAccordion,
    DownloadTheApp,
    MainFooter,
  },
});
</script>